import { Observable } from 'rxjs';
import { HttpClient, HttpHandler, HttpParams, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

export abstract class JsonApiService extends HttpClient {
    constructor(backend: HttpHandler) {
        super(backend);
    }

    // @Override
    get(url: string, params: Object = null): Observable<any> {
        const search = this.toSearch(params);
        return super.get(url, { params: search }).pipe(map(this.toJson));
    }

    // // @Override
    post(url: string, params: Object = null, options?: Object): Observable<any> {
        // const body = this.toBody(params);
        if (!options) {
            const header = this.getHeader();
            options = { headers: header };
        }
        return super.post(url, params, options).pipe(map(this.toJson));
    }

    postFile(url: string, params: Object = null, options?: Object) {
        const body = params;
        if (!options) {
            const header = this.getFileHeader();
            options = { headers: header };
        }
        return super.post(url, body, options).pipe(map(this.toJson));
    }

    // @Override
    put(url: string, params: Object = null): Observable<any> {
        const body = this.toBody(params);
        const header = this.getHeader();
        const options = { headers: header };
        return super.put(url, body, options).pipe(map(this.toJson));
    }
    // @Override
    delete(url: string, params: Object = null, options?: Object): Observable<any> {
        params = this.toSearch(params);
        if (!options) {
            const header = this.getHeader();
            options = { headers: header, params: params };
        }
        return super.delete(url, options).pipe(map(this.toJson));
    }

    private getHeader = () => new HttpHeaders({ 'Content-Type': 'application/json' });
    // private getHeader = () => (new HttpHeaders({ 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' }));
    // private getHeader = () => (new HttpHeaders({ 'Content-Type': 'application/json' }));
    private getFileHeader = () => new HttpHeaders();
    private toJson = (res: Response) => {
        return res.json ? res.json() : res;
    };
    private toBody = (params: Object): string => (params ? JSON.stringify(params) : '');

    /**
     * @param params
     * @param key Used ehen accessing nested properties inside params during recursivity
     * @param search Object to append params on it, during recursivity
     */
    private toSearch(params: Object | any[], key: string = null, search = new HttpParams()): HttpParams {
        if (params === undefined || params === null) {
            return search;
        }

        if (params instanceof Array && key) {
            // If it is an array, add brackets with the indexes: param[0]: value
            params.forEach((p, i) => (search = this.toSearch(p, `${key}[${i}]`, search)));
        } else if (params instanceof Object) {
            // If it is an object, add brackets wit the keys: param[key]: value
            Object.keys(params).forEach(
                (objKey) => (search = this.toSearch(params[objKey], key ? `${key}[${objKey}]` : objKey, search))
            );
        } else if (key) {
            // If the value is not an object nor and array, just append it with its key
            if (params === true) {
                // Transforming trues to 1
                search = search.append(key, '1');
            } else if (params === false) {
                // And falses to 0 (if necessary)
                search = search.append(key, '0');
            } else {
                search = search.append(key, params);
            }
        }

        return search;
    }
}
